import React from 'react';
import ComingSoon from './ComingSoon';

const Tours = () => {
  return <ComingSoon title="Tour & Attraction" />;
};

export default Tours;

